import { all, takeLatest } from "redux-saga/effects";

import { Types as UserTypes } from "../reducers/userReducer";
import { userChangePageSaga } from "./userSaga";

import { Types as ProfileTypes } from "../reducers/profileReducer";
import { profileChangePageSaga } from "./profileSaga";

export default function* rootSaga() {
  yield all([
    takeLatest(UserTypes.USER_CHANGE_PAGE_REQUEST, userChangePageSaga),
    takeLatest(ProfileTypes.PROFILE_CHANGE_PAGE_REQUEST, profileChangePageSaga),
  ]);
}
